import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory('indicator');

/**
 * indicator用アクション
 */
export const actions = {
	BEGIN: 'BEGIN',
	END: 'END',
} as const;

/**
 * indicatorアクション用ペイロード
 */
export interface IndicatorPayload {
	/**
	 * indicator制御用キー
	 */
	key: string;
}

/**
 * indicator表示
 */
export const begin = actionCreator<IndicatorPayload>(actions.BEGIN);

/**
 * indicator非表示
 */
export const end = actionCreator<IndicatorPayload>(actions.END);



// WEBPACK FOOTER //
// ./src/actions/indicator.ts